import WarningIcon from "./icons/WarningIcon";
import "./WarningNotice.scss";

interface Props {
  text: React.ReactNode;
  action?: React.ReactNode;
}

export default function WarningNotice({text, action}: Props) {
  return <div className={"warning-notice"}>
    <div>
      <WarningIcon />
      <span>{text}</span>
    </div>
    {action && <div className={"warning-notice-action"}>{action}</div>}
  </div>
}
